import styled from 'styled-components/native';

export const TouchableOpacity = styled.TouchableOpacity``;
